import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Email } from '../../../../images/svgs/email.svg';
import styles from './FooterContact.module.css';

export default function FooterContact() {
  const { t } = useTranslation('footer');
  const emailAddr = t('E_MAIL');
  const mailHref = `mailto:${emailAddr}?cc=${t('E_MAIL_CC')}`;
  return (
    <div className={styles.root}>
      <div className={styles.item}>
        <div className={styles.title}>{t('STILL_HAVE_DOUBTS')}</div>
        <div className={styles.contactBlock}>
          <div className={styles.mb2}>
            <a
              href={mailHref}
              target='_blank'
              rel='noopener noreferrer'
              className={styles.subtitle}>
              {t('SEND_AN_EMAIL')}
            </a>
          </div>
          <div className={styles.emailRow}>
            <Email width={16} height={10} fill='white' />
            <a
              href={mailHref}
              target='_blank'
              rel='noopener noreferrer'
              className={styles.link}>
              {emailAddr}
            </a>
          </div>
        </div>
      </div>
      <div className={styles.item}>
        <div className={styles.title}>{t('OPENING_HOURS')}</div>
        <p className={styles.text}>
          {t('OPENING_HOURS_CUSTOMER')}
          <br />({t('MONDAY_TO_FRIDAY')})
        </p>
        <p className={styles.text}>
          {t('OPENING_HOURS_SUPPORT')}
          <br />({t('MONDAY_TO_FRIDAY')})
        </p>
      </div>
    </div>
  );
}
